import MovementModal from "./MovementModal";
import { Modal, ModalHeader } from "../../modal/Modal";
import TakeBiometricMovements from "../TakeBiometricMovements";
import React, { useEffect, useState } from "react";
import crossBtn from "../../../assets/img/utils/cross.svg";
import GLOBAL from "../../../global";
import routes from "../../../constants/Routes";
import {useHistory} from "react-router-dom";
import { useTenantFeatures } from "../../../features/tenantFeatures/useTenantFeature";

const BiometricMovementAndCautionQuestionContainer = (props) => {
    const { data, setOpenBiometricMovementAndCautionQuestionContainer } = props;
    const { testId, selectedBodyRegions, openBiometricMovementAndCautionQuestionContainer } = data;
    const history = useHistory();

    const [openMovementModal, setOpenMovementModal] = useState(false);
    const [cautionQuestionModal, setCautionQuestionModal] = useState(false);

    const { isCautionQuestionEnable } = useTenantFeatures();
    const isCautionQuestionEnabled = isCautionQuestionEnable ?? true;

    useEffect(() => {
        if(openBiometricMovementAndCautionQuestionContainer) {
            // Only trigger if no modal is currently open to prevent repeated openings on re-renders
            if (openMovementModal || cautionQuestionModal) return;

            if(selectedBodyRegions?.bodyRegionList.find(item => item.toString() === "5") || !isCautionQuestionEnabled) {
                setOpenMovementModal(true);
                return;
            }
            setCautionQuestionModal(true);
        }
    }, [openBiometricMovementAndCautionQuestionContainer, selectedBodyRegions, isCautionQuestionEnable, openMovementModal, cautionQuestionModal]);

    const onCloseMovementModal = () => {
        setOpenMovementModal(false);
        GLOBAL.ASSESSMENT = null;
        GLOBAL.ALREADY_CALLED_API = false;
        // Let MovementCore handle navigation after biometric completion
        // Don't automatically redirect back to MyAssessments
        // history.push(`${routes.myAssessments}/false`);
        // window.location.replace(`${routes.myAssessments}/false`)
        clearData();
    };

    const onClickMovementCell = () => () => {
        GLOBAL.ASSESSMENT = null;
        setOpenMovementModal(true);
    };

    const clearData = () => {
        setCautionQuestionModal(false);
        ////TODO: will shift to redux then will fix the function name `setOpenBiometricMovementAndCautionQuestionContainer` with appropriate name
        // should not change to true from false as in all component we're using this to close the modal
        setOpenBiometricMovementAndCautionQuestionContainer(false);
        setOpenMovementModal(false);
    }

    const closeBtn = (
        <img src={crossBtn} onClick={clearData} type="button" alt="cross" />
    );

    return(
        <>
            {openBiometricMovementAndCautionQuestionContainer && (
                <>
                    {openMovementModal && (
                        <MovementModal
                            open={openMovementModal}
                            selectedRegion={selectedBodyRegions}
                            testId={testId}
                            onClose={onCloseMovementModal}/>
                    )}
                    {cautionQuestionModal && (
                        <Modal
                            isOpen={cautionQuestionModal}
                            contentClassName="custom-modal-style"
                            backdrop={true}
                            className="biometric-modal-container">
                            <ModalHeader
                                toggle={clearData}
                                close={closeBtn}
                                className="biometric-modal-header movement-caution">
                                <span className={"font-size-lg color-red"}>
                                    Caution
                                </span>
                            </ModalHeader>
                            <TakeBiometricMovements
                                setTakeBiometricMovementModal={setCautionQuestionModal}
                                data={{
                                    TestId: testId,
                                    BodyRegionList: selectedBodyRegions?.bodyRegionList || selectedBodyRegions || []
                                }}
                                onClickMovementCell={onClickMovementCell}>
                            </TakeBiometricMovements>
                        </Modal>
                    )}
                </>
            )}
        </>

    )
}

export default BiometricMovementAndCautionQuestionContainer;
